module.exports = __webpack_public_path__ + "img/expand-left.27bd656f.png";